import React from 'react';
import Search from './Search';
import { SetupPage } from 'areas/shared/pages/setup';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as API from 'modules/app/API'
import * as Help from 'modules/app/Help'
import DiscountCodeInfoTab from './discountCodeInfo/DiscountCodeInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import DiscountCodeLink from 'areas/shared/components/formatter/DiscountCodeLink';

class DiscountCodeSetup extends React.Component {

    render() {
        let opts = {
            setupKey: "discountCodeSetup",
            title: "Discount Code Search",
            description: "",
            addNewTitle: "Generate new Discount Code",
            helpKey: Help.discountCodeSetupHelpKey,
            addPrivilege: false,
            enableColumnSettings: true,
			disableSelect: true,
            recentType: "discountCode",
            sortField: "startDate",
			sortDirection: "DESC",
			
            list: {
                url: API.DiscountCode.url('/discountCodeSetup/search'),
                rowKey: "discountCodeId",
			columns: [
                    { key: 'sponsorId', name: 'CM ID', sortable: false, width: 70 },
                    { key: 'sponsorName', name: 'MEMBER', sortable: true },
                    { key: 'code', name: 'Code', formatter: DiscountCodeLink, getRowMetaData: (row) => row, sortable: false },
					{ key: 'sponsorTypeCode', name: 'TYPE', sortable: true },
                    { key: 'startDate', name: 'Start', width: 90, formatter: Formatter.Date, sortable: true },
					{ key: 'endDate', name: 'End', width: 90, formatter: Formatter.Date, sortable: true },
                    { key: 'issued', name: 'Issued', sortable: false },
					{ key: 'used', name: 'Used', sortable: false },
                    { key: 'vobName', name: 'VOB', sortable: true },
                    { key: 'certificationId', name: 'APP ID', sortable: true },
                    { key: 'balance', name: 'Balance', sortable: true },
					{ key: 'active', name: 'Active', formatter: Formatter.Check, width: 50, cellClass: "text-center", sortable: false }
				]
            },
			tabs: [
                { key: "discountCode", title: "Discount Code", comp: DiscountCodeInfoTab },
				{ key: "auditInfo", title: "Audit Info", comp: AuditInfoTab, helpKey: Help.discountCodeSetupAuditHelpKey }
            ]
        };

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}
export default DiscountCodeSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/discountCodeSetup/DiscountCodeSetup.js